import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import LoginElement from "../auth/left-panel";
import { Link } from "react-router-dom";


const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // ✅ Basic email validation
    return emailRegex.test(email);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    let validationErrors = {};

    // Email validation
    if (!email) {
      validationErrors.email = "Email is required.";
    } else if (!validateEmail(email)) {
      validationErrors.email = "Please enter a valid email address.";
    }

    // Password validation
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

  };


  return (
    <div className="login">
      <div className="content-section">
        <LoginElement/>
      </div>
      <div className="form-section">
        <div className='l-form-element l-forgot'>
          <h1>Forgot Password?</h1>
          <p>Enter your registered email account or username</p>
          <Form onSubmit={handleLogin}>
            {/* Email Input Group with Validation */}
            <div className="mb-3">
              <Form.Floating>
                <Form.Control
                  id="floatingInputCustom"
                  type="email"
                  placeholder="name@example.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className={errors.email ? "is-invalid" : ""}
                />
                <label htmlFor="floatingInputCustom">Email or Username</label>
              </Form.Floating>
              {errors.email && <div className="text-danger mt-1">{errors.email}</div>} {/* ✅ Email error message */}
            </div>

            {/* Submit button */}
            <Button type="submit" className="btn btn-primary w-100 login-btn">
                Send Reset Link
            </Button>

            {/* Forgot Password link */}
            <div className="resend mt-2">
              <Link to="/forgot-password">Resend</Link>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
